interface ErrorResponse {
    code: string | number;
    message: string;
    details?: any[];
}

export interface AuthState {
    authGuestData: any | null;
    authGuestLoading: boolean;
    authGuestDataError: ErrorResponse | null;
}

export enum AuthGuestActionTypes {
    FETCH_AUTH_GUEST_DATA         = "FETCH_AUTH_GUEST_DATA",
    FETCH_AUTH_GUEST_DATA_SUCCESS = "FETCH_AUTH_GUEST_DATA_SUCCESS",
    FETCH_AUTH_GUEST_DATA_ERROR   = "FETCH_AUTH_GUEST_DATA_ERROR",
    CLEAR_AUTH_GUEST_DATA = "CLEAR_AUTH_GUEST_DATA",
}

export type AuthGuestCreateAction =
    | { type: AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA }
    | { type: AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA_SUCCESS; payload: any }
    | { type: AuthGuestActionTypes.CLEAR_AUTH_GUEST_DATA; payload: [] }
    | { type: AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA_ERROR;   payload: ErrorResponse };